export const ATT_MATRIX_VALS = {
  REQ: 0,
  OPT: 1,
  ADV: 2,
  NA: 3,
};

interface NavItemData {
  text: string;
  step: string;
  pathname: string;
}

export const NAV_ITEMS: NavItemData[] = [
  {
    text: "Sản phẩm",
    pathname: "/wizard/step-1",
    step: "1",
  },
  {
    text: "Bố cục",
    pathname: "/wizard/step-2",
    step: "2",
  },
  {
    text: "Phong cách",
    pathname: "/wizard/step-3",
    step: "3",
  },
  {
    text: "Nội dung",
    pathname: "/wizard/step-4",
    step: "4",
  },
  {
    text: "Đặt hàng",
    pathname: "/wizard/step-5",
    step: "5",
  },
];

export const ROUTES = {
  step1: {
    prev: "/",
    curr: "/wizard/step-1",
    next: "/wizard/step-2",
  },
  step1b: {
    prev: "/wizard/step-1",
    curr: "/wizard/step-1/products",
    next: "/wizard/step-2",
  },
  step1c: {
    prev: "/wizard/step-1/products",
    curr: "/wizard/step-1/products/:productId",
    next: "/wizard/step-2",
  },
  step2: {
    prev: "/wizard/step-1",
    curr: "/wizard/step-2",
    next: "/wizard/step-3",
  },
  step3: {
    prev: "/wizard/step-2",
    curr: "/wizard/step-3",
    next: "/wizard/step-4",
  },
  step4: {
    prev: "/wizard/step-3",
    curr: "/wizard/step-4",
    next: "/wizard/step-5",
  },
  step5: {
    prev: "/wizard/step-4",
    curr: "/wizard/step-5",
    next: "/order/success",
  },
  default: {
    prev: "/",
    curr: "/",
    next: "/",
  },
};



// WEBPACK FOOTER //
// ./src/routes/Wizard/constants.ts